var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup2085663920(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 7H1.16667C0.522334 7 0 7.52233 0 8.16667V14C0 14.6443 0.522334 15.1667 1.16667 15.1667H2.33333C2.97767 15.1667 3.5 14.6443 3.5 14V8.16667C3.5 7.52233 2.97767 7 2.33333 7Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 2.25H7.58301C7.9512 2.25 8.25 2.5488 8.25 2.91699V14C8.25 14.3682 7.9512 14.667 7.58301 14.667H6.41699C6.0488 14.667 5.75 14.3682 5.75 14V2.91699L5.76367 2.78223C5.82588 2.47849 6.09486 2.25 6.41699 2.25Z",
    stroke: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 0.5H12.833C13.2012 0.5 13.5 0.798802 13.5 1.16699V14C13.5 14.3682 13.2012 14.667 12.833 14.667H11.667C11.2988 14.667 11 14.3682 11 14V1.16699C11 0.798802 11.2988 0.5 11.667 0.5Z",
    stroke: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2085663920);
export default __webpack_public_path__ + "static/media/Group_2085663920.fdd5c8dc83514ef0120049f8c9446d35.svg";
export { ForwardRef as ReactComponent };